<template lang="pug">
  .message(:class='{reduced: message.reduced, hide: hidden, sending: message.sending}', @click='expand')
    vue-object-img(:object='message.sender')
    small.time(:title="message.time | unixtimeTo('LT')") {{ message.time | unixtimeTo('calendar') }}
    h4(@click=' toggleReduced') {{ message.sender.name }}
    .body(v-if='message.reduced') {{ message.text }}
    .body(v-if='!message.reduced')
      embed-text 
        mark-text {{message.text}}

</template>
<script>
import VueObjectImg from '@/components/shared/VueObjectImg'
import {unixtimeTo} from '@/components/shared/vue.globals'

import EmbedText from '@/components/shared/EmbedText'
import MarkText from '@/components/shared/MarkText'

import _ from 'lodash'

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    hidden: {
      default: false
    },
    reduced: {
      default: false
    }
  },
  data () {
    return {}
  },
  components: {
    VueObjectImg,
    EmbedText,
    MarkText
  },
  created () {},
  mounted () {
    if (_.isUndefined(this.message.reduced)) {
      this.$set(this.message, 'reduced', this.reduced)
    }
  },
  destroyed () {},
  computed: {},
  methods: {
    toggleReduced (e) {
      e.stopPropagation()
      this.message.reduced = !this.message.reduced
    },
    expand (e) {
      e.stopPropagation()
      this.message.reduced = false
    }
  },
  filters: {
    unixtimeTo
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// Message.vue?49ecf0a0